import { invoke } from '@shared/easyfy.decorators';
import Events, { ServiceNames } from '@shared/easyfy.events/easyfy.eventhandler';
import { Ga4DataMapper } from '@clientWebModules/eventMappers/dataMapper.ga4';
import { StatsDataMapper } from '@shared/easyfy.events/mappers/dataMapper.stats';
import { KlaviyoDataMapper } from '@clientWebModules/eventMappers/dataMapper.klaviyo';
import { IDataMapper } from '@shared/easyfy.events/easyfy.eventdata';
import Search, { SearchConfig } from '@clientWebModules/search';
import '@clientWebModules/header';
import '@clientWebModules/salesunitselector';
import '@clientWebModules/dialogmodal';
import '@clientShared/toggle';
import '@clientShared/form';
import '@clientShared/logout';
import '@clientLogin/otp-flow';
import '@clientLogin/otp-digit-inputs';
import AgeGate from '@clientWebModules/agegate';
import '@clientWebModules/optionselector';
import SubscriptionHelper from '@clientShared/subscriptionHelper';
import NotifyMe from '@clientWebModules/notifyme';
import CountryPopup from '@clientWebModules/countrypopup';
import Kevel from '@clientWebModules/kevel';
import KevelFloatingAd from '@clientWebModules/kevelFloatingAd';
import { HayppFeatureNames } from '@clientShared/HayppFeatureNames';
import { Features } from '@webServices/features.service';
import { KevelDataMapper } from '@clientWebModules/eventMappers/dataMapper.kevel';
import { shouldManuallyTrackElementImpression } from '@clientShared/eventTracking';

@invoke
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class Global {
  constructor() {
    if (Features.FeatureIsActive(HayppFeatureNames.Kevel)) void new Kevel();

    new Search(new SearchConfig(2, 'grid')).OnInit();
    void new Events.EasyfyEventHandler(
      new Map<string, IDataMapper>([
        [ServiceNames.Ga4, new Ga4DataMapper()],
        [ServiceNames.Stats, new StatsDataMapper()],
        [ServiceNames.Klaviyo, new KlaviyoDataMapper()],
        [ServiceNames.Kevel, new KevelDataMapper()],
      ]),
      {
        shouldManuallyTrackElementImpression,
      }
    );
    void new AgeGate();
    void new CountryPopup();
    void new SubscriptionHelper();
    void new NotifyMe();
    void new KevelFloatingAd();
  }
}
